var neutral = {
  variant: 'neutral'
};
var negative = {
  variant: 'negative'
};
var caution = {
  variant: 'caution'
};
var informative = {
  variant: 'informative'
};
var toastVariants = {
  neutral: neutral,
  negative: negative,
  caution: caution,
  informative: informative
};

export { toastVariants };
//# sourceMappingURL=toast.variants.esm.js.map
